import { Button, Divider, Feedback, Text } from "@stone-payments/jade";
import { useIsStoreOpen } from "@/hooks/use-is-store-open";

export const ClosedStoreCart = () => {
  const { openingHours } = useIsStoreOpen();

  return (
    <>
      <div className="flex h-[calc(100vh-68px)] items-center justify-center pb-37.5">
        <div className="mt-12">
          <Feedback
            title="Fechado no momento"
            description="Confira o horário de funcionamento:"
            variant="negative"
            icon="circle-clock"
          />

          <div className="mt-2">
            <Text
              variant="text-small"
              color="medium"
              className="text-center whitespace-pre-line"
            >
              {openingHours}
            </Text>
          </div>
        </div>
      </div>
      <div className="absolute right-0 bottom-0 left-0 bg-white">
        <Divider />

        <div className="flex flex-col gap-jade-150 p-jade-250">
          <Button
            className="w-full"
            variant="neutral-subtle"
            icon="circle-clock"
            disabled
          >
            Loja fechada
          </Button>
        </div>
      </div>
    </>
  );
};
